import Vue from "vue";
import App from "./App.vue";

// router
import VueRouter from "vue-router";
import router from "./router";

// element UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// naver map
import naver from "vue-naver-maps";

import vuex from "vuex";

import VueSimpleAlert from "vue-simple-alert";

// cookie
import VueCookies from "vue-cookies";

// axios root
import build from "./api/example";

// import 'core-js/stable'
// import 'regenerator-runtime/runtime'

// 쿠키 사용 설정
Vue.use(VueCookies);

Vue.config.productionTip = false;

Vue.use(vuex);

Vue.use(ElementUI);

// router
Vue.use(VueRouter);

// 알림창
Vue.use(VueSimpleAlert, { reverseButtons: true });

var routeList = [];

// var domain = "parking2.gmuc.co.kr";
// var path = "/"
// var expiredDate = "1d";

// // 쿠키 만료시간(1일)
// Vue.$cookies.config(expiredDate, path, domain);

const store = new vuex.Store({
  state: {
    isLogin: false, //로그인 확인
    isAdmin: false, //최상위 관리자 확인
    isBusiness: false, //사업자 확인
    isActive: false, //메뉴
    isSubmit: false, //메뉴
    isCheck: false, //메뉴
    isCoin: false, //메뉴
    mainMenu: false,
    firstMenu: false, //메인 메뉴
    secondMenu: false, //메인 메뉴
    thirdMenu: false, //메인 메뉴
    fourthMenu: false, //메인 메뉴
    clientID: null,
    popupCheck: false,

    loginMemberIndex: null,
  },
  actions: {
    getNaverClientId(state) {
      build
        .get("/api/parkingLot/mapId")
        .then(res => {
          state.commit("setClientId", res.data);

          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    setClientId(state, dispatch) {
      state.clientID = dispatch;
    },
  },
});

Vue.use(naver, {
  clientID: "qt0c83c2b2",
});
//wpi5leimta -> 서버 IP
//ls4l8obquh -> 내 IP
//87bf1tlvv5 -> 팀장님 IP
// 광명
// qt0c83c2b2


router.onError((error) => {
  if (/Loading chunk [\d]+ failed/.test(error.message)) {
    window.location.reload(true);
  }
});


router.beforeEach((to, from, next) => {
  // const loggedIn = localStorage.getItem('user')

  // console.log(to);

  var index = -1;
  for (var i = 0; i < routeList.length; i++) {
    if (routeList[i].name == to.name) {
      index = i;
      break;
    }
  }
  if (index !== -1) {
    routeList.splice(index + 1, routeList.length - index - 1);
  } else if (to.name != "  ") {
    routeList.push({ name: to.name, path: to.fullPath });
  }
  to.meta.routeList = routeList;

  next();

  return false;
});

new Vue({
  el: "#app",
  router,
  store,
  // naverClintId,
  render: h => h(App),
});
